import React, {useEffect, useState} from 'react'
import {FaArrowRight} from 'react-icons/fa'
import {Container, Card, Badge, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
const HomeProductsProvider = ({productsData, title, tag, setSearch}) => {
  const [products, setProducts] = useState([])
  useEffect(() => {
    
    setProducts(productsData)
    console.log(products);
  },[])

  return <Container>
    <Link className=" text-decoration-none" to={`/products/${title}`}>
  <h5 onClick={() =>{console.log(title); setSearch(title)}} className="mb-1 mt-3 text-capitalize text-dark" style={{userSelect:"none"}}>{title}<FaArrowRight style={{marginLeft:".5rem"}}/></h5>
  </Link>
  <Row className="justify-content-center">
  {
    products.map((product, index) => {
      if(index < 12){
        return<Col  className=" border-0 text-left g-4 mb-4 p-2" lg={2}  md={3} sm={6}> <Link key={product.id} to={`/product/${product.id}`} > <Card >
  <Card.Img className="h-50 w-100" variant="top" src={product.image} />
  <Card.Body className="py-3 px-unset" style={{padding:"unset"}}>
    <Badge className="text-bold text-left p-3 bg-success text-light w-100" style={{borderRadius:"10px"}}>${product.price}</Badge>
  </Card.Body>
</Card></Link></Col>
      }
      })
  }
    </Row>
  </Container>
}

export default HomeProductsProvider